module.exports = __webpack_public_path__ + "img/mariajosemaillard.8706770c.jpg";